export const PHARMACY_NUMBER = '+17809610101'